<template>
    <vx-prompt
        v-if="localActive"
        :title="title"
        :active.sync="localActive"
        class="image-popup"
        :class="{ zoomed: imageZoomed }"
    >
        <vx-scroll-area>
            <img :src="src || ''" alt="image" class="w-full" @click="imageZoomed = !imageZoomed" />
        </vx-scroll-area>
    </vx-prompt>
</template>

<script>
export default {
    name: 'vx-image-preview',
    props: {
        active: {
            type: Boolean,
            required: true
        },
        src: {
            type: String,
            required: true
        },
        title: {
            type: String
        }
    },
    data() {
        return {
            imageZoomed: false
        }
    },
    computed: {
        localActive: {
            get() {
                return this.active
            },
            set(v) {
                this.$emit('update:active', v)
            }
        }
    }
}
</script>

<style scoped>
.image-popup {
    z-index: 54000;
}
.vx-scroll-area {
    max-height: calc(100vh - 10rem);
}
.image-popup >>> .vs-dialog-text {
    margin: 0 auto;
    overflow: hidden;
}
.image-popup.zoomed >>> .vs-dialog-text {
    transform: scale(1.5);
}
.image-popup >>> img {
    cursor: zoom-in;
}
.image-popup.zoomed >>> img {
    cursor: zoom-out;
}
</style>
